// src/context/AnnouncementContext.js
import React, {
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";

import {
  getAllAnnouncements,
  createAnnouncement,
  updateAnnouncement,
  deleteAnnouncement,
} from "../services/announcementService";

// ค่าตั้งต้น เวลา component ไหนยังไม่ได้ถูก wrap ด้วย Provider
const AnnouncementContext = createContext({
  announcements: [],
  addAnnouncement: () => {},
  editAnnouncement: () => {},
  removeAnnouncement: () => {},
  reloadAnnouncements: () => {},
});

export function AnnouncementProvider({ children }) {
  const [announcements, setAnnouncements] = useState([]);

  // โหลดครั้งแรก
  useEffect(() => {
    reloadAnnouncements();
  }, []);

  async function reloadAnnouncements() {
    try {
      setAnnouncements(await getAllAnnouncements());
    } catch (err) {
      console.warn("[AnnouncementContext] load failed:", err.message); // pages that need the list show their own error
    }
  }

  // === ฟังก์ชันที่ component อื่นจะเรียกใช้ ===

  // ใช้ตอน "ลงประกาศ" (หน้าเก่าที่ error อยู่)
  async function addAnnouncement(data) {
    const created = await createAnnouncement(data);
    // ใส่เข้า state ทันที (จะได้เห็นรายการล่าสุด)
    setAnnouncements((prev) => [created, ...prev]);
    return created;
  }

  // สำหรับแก้ไข (ถ้าอยากให้หน้าฟอร์มเดิมใช้ context ด้วย)
  async function editAnnouncement(id, data) {
    const updated = await updateAnnouncement(id, data);
    setAnnouncements((prev) =>
      prev.map((item) => (item.id === id ? updated : item))
    );
    return updated;
  }

  // สำหรับลบ
  async function removeAnnouncement(id) {
    await deleteAnnouncement(id);
    setAnnouncements((prev) => prev.filter((item) => item.id !== id));
  }

  return (
    <AnnouncementContext.Provider
      value={{
        announcements,
        addAnnouncement,
        editAnnouncement,
        removeAnnouncement,
        reloadAnnouncements,
      }}
    >
      {children}
    </AnnouncementContext.Provider>
  );
}

// hook ไว้ให้ import ใช้ง่าย ๆ
export function useAnnouncements() {
  return useContext(AnnouncementContext);
}

// ถ้าโปรเจคเก่าเคย import AnnouncementContext โดยตรงอยู่ ก็ export ไว้ให้ด้วย
export default AnnouncementContext;
